import type { EntityGenerateInputs } from "~shared/agenticChat/entityGenerateUserMessageContent";
import type { CTAAction, CTAActionType } from "../components/PersistentChat/ThinkingStep/cta-types";

const ENTITY_GENERATE_DISPLAY_TITLES: Partial<Record<CTAActionType, string>> = {
  generate_character: "Generate Character",
  generate_worldbuilding: "Generate Element",
};

export function entityGenerateCtaActionFromUserMessage(
  userMessage:
    | {
        content?: string;
        metadata?: {
          generateInputs?: EntityGenerateInputs;
          ctaActionType?: string;
        };
      }
    | undefined,
  ctaActionType?: string,
): CTAAction | undefined {
  const type = (ctaActionType ?? userMessage?.metadata?.ctaActionType) as CTAActionType | undefined;
  if (type !== "generate_character" && type !== "generate_worldbuilding") return undefined;

  const inputs = userMessage?.metadata?.generateInputs;
  if (!inputs) return undefined;

  const displayTitle = ENTITY_GENERATE_DISPLAY_TITLES[type] ?? "Generate";
  const baseUserMessage = typeof userMessage?.content === "string"
    ? userMessage.content.split("\n")[0]?.trim() || displayTitle
    : displayTitle;

  return {
    type,
    status: "completed",
    displayTitle,
    userMessage: baseUserMessage,
    cannedResponse: "",
    customInstructions: inputs.description,
    role: inputs.role,
    roleLabel: inputs.roleLabel,
    roleExplicitlySelected: inputs.roleExplicitlySelected,
  };
}
